module.exports = __webpack_public_path__ + "img/newLocation.cd3c4aae.svg";